import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import useTranslation from '@modules/hooks/useTranslation';
import { getFAQList, incrementViewAPI } from '@modules/api/faq';
import styles from '@styles/FAQ.module.scss';

const FAQ = ({
    data,
}: {
    data: {
        categoryList: { ko: string[]; en: string[] };
        data: { id: number; category: string; question: string; answer: string }[];
    };
}) => {
    const { t, locale } = useTranslation('faq');

    const [category, setCategory] = useState(data.categoryList[locale as 'ko' | 'en'][0]);

    const [openIdList, setOpenIdList] = useState<number[]>([]);

    const { mutateAsync: incrementView } = incrementViewAPI();
    const onOpenClick = (id: number) => {
        if (!openIdList.includes(id)) setOpenIdList([...openIdList, id]);
        else {
            const tmp = openIdList.filter((item) => item !== id);
            setOpenIdList(tmp);
        }
        incrementView(id);
    };

    useEffect(() => {
        setCategory(data.categoryList[locale as 'ko' | 'en'][0]);
    }, [locale]);

    useEffect(() => {
        setOpenIdList([]);
    }, [category]);

    return (
        <>
            <Head>
                <title>{t('title')}</title>
                <meta property="og:title" content={t('title')} />
            </Head>

            <div id="container" className={styles.container}>
                <h1 className={styles.title}>{t('title')}</h1>

                <ul className={styles.category_list}>
                    {data?.categoryList[locale as 'ko' | 'en'].map((item: string, index: number) => (
                        <li
                            key={`category-${index}`}
                            className={`${styles.category_item} ${item === category ? styles.active : ''}`}
                        >
                            <button type="button" onClick={() => setCategory(item)}>
                                {item}
                            </button>
                        </li>
                    ))}
                </ul>

                <ul className={styles.qna_list}>
                    {data?.data
                        .filter((item) => item.category === category)
                        .map((item) => (
                            <li key={item.id} className={styles.qna_item}>
                                <button type="button" onClick={() => onOpenClick(item.id)} className={styles.question}>
                                    <span>{item.question}</span>
                                </button>
                                <p className={`${styles.answer} ${openIdList.includes(item.id) ? styles.open : ''}`}>
                                    {item.answer}
                                </p>
                            </li>
                        ))}
                </ul>
            </div>
        </>
    );
};

export default FAQ;

export async function getServerSideProps() {
    const { data } = await getFAQList();
    return {
        props: data,
    };
}
